// * ========================================================================
// * Collection maker functionality
// * ========================================================================

'use strict';

import $ from 'jquery';
import Cookies from 'js-cookie';
import datalayerActions from './analytics-actions';

const collectionMaker = (function () {
  const block = '.js-collection-maker';

  let $cmElement = null,
    $dialogElem = null,
    ajaxHandlerUrl = null,
    initializerUrl = null,
    basketId = 'default-basket',
    imageQuality = null,
    currentPhase = 'notrunning',
    percentPerPoll = 0,
    pdfProgress = 0;

  function generalAjax(ajaxUrl, params = {}, type = 'GET', callback, cbParams = {}){
    $.ajax({
      url: ajaxUrl,
      type: type,
      data: params,
      cache: false
    }).done(function (resp) {
      if(typeof(callback) !== 'undefined'){
        callback(resp, cbParams);
      }
    });
  }

  /*
  *
  * Functions that are used outside collection maker page
  *
  */

  // Item removed from collection maker (button)
  function itemRemoved(resp, $item){
    if($item){
      $item.data('in-cart', false);
      $item.text($item.data('text-add'));
    }
  }

  // Item added to collection maker (button)
  function itemAdded(resp, $item){
    if($item){
      $item.data('in-cart', true);
      $item.text($item.data('text-remove'));
    }
  }

  // Toggle single cart item
  function toggleCartItem(id, inCart, $item){
    let urls = [];
    let action = inCart ? 'remove' : 'add';
    let callback = inCart ? itemRemoved : itemAdded;

    urls.push(id);

    generalAjax(ajaxHandlerUrl, { action: action, urls: urls, basket: basketId }, 'POST', callback, $item);
  }

  // Check if items belong to cart
  function cartLoaded(cart){
    // Each cart toggle button
    $.each($(block+'__item-cart-toggle'), function(i, item){
      let $item = $(item);
      let id = $item.data('item-id');
      if($.inArray(id, cart) !== -1){
        $item.data('in-cart', true);
        $item.text($item.data('text-remove'));
      }
    });

    // Click cart toggle button
    $(block+'__item-cart-toggle').on('click', function(e){
      e.preventDefault();
      let $item = $(this);
      let id = $item.data('item-id');
      let inCart = $item.data('in-cart');

      toggleCartItem(id, inCart, $item);
    });

    // Each cart toggle checkbox
    $.each($(block+'__checkbox-cart-toggle'), function(i, input){
      let $input = $(input);
      let id = $input.val();
      if($.inArray(id, cart) !== -1){
        $input.prop('checked', true);
      }
    });

    // Checkbox change
    $(block+'__checkbox-cart-toggle').on('change', function(){
      let $input = $(this);
      let id = $input.val();
      let inCart = !$input.prop('checked');

      toggleCartItem(id, inCart, null);
    });

  }

  // Load initial cart
  function loadCart(resp){
    generalAjax(ajaxHandlerUrl, { action: 'loadCart' }, undefined, cartLoaded);
  }

  // Initialize stage dlcenter
  function initCart() {
    generalAjax(initializerUrl, { action: 'initialize' }, undefined, loadCart);
  }

  /*
  *
  * Collection maker page functions
  *
  */

  // clear whole cart
  function clear() {
    $.ajax({
      url: ajaxHandlerUrl,
      data: {
        basket: basketId,
        action: 'clear'
      },
      cache: false
    }).done(function (resp) {
      // refresh
      window.location.reload();
    });
  }

  function unselectParents($parents) {
    $parents.each(function () {
      const $parent = $(this);
      let selectedChildren = $parent.children('ul').find(block + '__toggle:checked');
      if (selectedChildren.length === 0) {
        $parent.children(block + '__item').find(block + '__toggle').prop('checked', false);
      }
    });
  }

  function selectParents($parents) {
    $parents.children(block + '__item').find(block + '__toggle').prop('checked', true);
  }

  function toggleItem() {
    let urls = [],
      $itemCheckbox = $(this),
      $parentLi = $itemCheckbox.closest(block + '__li'),
      add = $itemCheckbox.is(':checked'),
      itemUrl = $itemCheckbox.data('url') || null,
      $childItems = $parentLi.find('ul li ' + block + '__toggle'),
      $parentItems = $parentLi.parents(block + '__li');

    // Add current item url
    if (itemUrl) {
      urls.push(itemUrl);
    }

    // Toggle children & add urls
    $childItems.each(function () {
      let childUrl = $(this).data('url') || null;
      if (childUrl) {
        urls.push(childUrl);
      }
      $(this).prop('checked', add);
    });

    // Toggle parents
    if (add) {
      selectParents($parentItems);
    } else {
      unselectParents($parentItems);
    }

    $.ajax({
      url: ajaxHandlerUrl,
      type: 'post',
      data: {
        basket: basketId,
        action: (add ? 'add' : 'remove'),
        urls: urls
      },
      cache: false,
      success: function (resp) {
        $cmElement.data('count', resp.length);
      },
      error: function () {
        // show error notification
      }
    });
  }

  function requestPdf() {
    let pdfQuality = $(this).data('image-quality');
    let language = $('select.brochure-language').children('option:selected').val();
    $.ajax({
      url: ajaxHandlerUrl,
      type: 'get',
      data: {
        action: 'pdf',
        basket: basketId,
        imageQuality: pdfQuality,
        language: language
      },
      cache: false,
      success: function (data) {
        Cookies.set(basketId + '-dlcenter-waiting', data, { path: '/' });
        localStorage.setItem('prefLang', language);
        currentPhase = 'waitingTask';
        pdfProgress = 0;
        poll();
      }
    });
  }

  function createSendDialog(){
    let $elem = $('<div id="cm-send-dialog" class="cm-dialog" style="display: none;"></div>');
    if ($cmElement.find(block + '__send-links-dialog-template').length) {
      $elem.append($cmElement.find(block + '__send-links-dialog-template').clone().children());
      $('body').append($elem);

      $dialogElem = $('#cm-send-dialog');
      $dialogElem.fadeIn();

      $dialogElem.on('click', block+'__close-dialog', function(e){
        e.preventDefault();
        $dialogElem.fadeOut();

        // remove ?sendLinks=1
        let curUrl = document.location.href.split('?');
        if(window.history.pushState){
          window.history.pushState(null, null, curUrl[0]);
        }

      });
    }
  }

  function openSendForm(){
    var $dialogElem = $('#cm-send-dialog');
    if (!$dialogElem.length) {
      createSendDialog();
    }else{
      $dialogElem.fadeIn();
    }
  }

  function createDialog() {
    let $elem = $('<div id="cm-dialog" class="started cm-dialog" style="display: none;"></div>');
    if ($cmElement.find(block + '__dialog-template').length) {
      $elem.append($cmElement.find(block + '__dialog-template').clone().children());
      $('body').append($elem);

      $dialogElem = $('#cm-dialog');
      $dialogElem.fadeIn();

      $dialogElem.on('click', block+'__progress-abort', function(){
        Cookies.remove(basketId + '-dlcenter-waiting', { path: '/' });
        $dialogElem.fadeOut();
        resetDialogLoading($dialogElem);
      });

      $dialogElem.on('click', block+'__close-dialog', function(e){
        e.preventDefault();
        $dialogElem.fadeOut();
        resetDialogLoading($dialogElem);
      });
    }
  }

  function resetDialogLoading($dialogElem) {
    $dialogElem.find('.cm-dialog__progress-text').text('0%');
    $dialogElem.find('.cm-dialog__progress-indicator').stop().css('width', '0%');
  }


  function pollDone(data) {
    // delete process cookie
    Cookies.remove(basketId + '-dlcenter-waiting', { path: '/' });
    // do the default actions for default implementation
    $dialogElem.removeClass('started').addClass('success');
    $dialogElem.find(block + '__dllink').attr('href', data.retdata.url).text(data.retdata.text);
    $dialogElem.find('.cm-dialog__progress-indicator').stop().animate({ width: '100%' }, { duration: 500 });

    //download PDF click event
    $dialogElem.on('click', block + '__dllink', function(e){
      let gaEvent = {
        'event': 'brochureGenerated',
        'brochureQuality': data.params.imageQuality,
        'brochureDownloadContents': data.retdata.itemNames
      };
      datalayerActions.pushObjectToDatalayer(gaEvent);
    });
  }

  function pollFail() {
    // show error
    Cookies.remove(basketId + '-dlcenter-waiting', { path: '/' });
    $dialogElem.removeClass('started').addClass('error');
  }

  function pollRunning(data) {
    let progress = Math.floor(parseFloat(data.retdata.progress));
    switch (currentPhase) {
    case 'waitingTask':
      currentPhase = 'running';
      break;
    case 'running':
      if (data.retdata.phase && data.retdata.phase === 'pdf') {
        currentPhase = 'pdf';
        percentPerPoll = (45 / data.params.pages.length) * 8;
      }
      break;
    case 'pdf':
      pdfProgress += percentPerPoll;
      break;
    }
    // displayProgress uses "true" or simulated progress depending if bg task supports true
    let displayProgress = data.retdata.phase ? progress : Math.min(Math.floor(0.55 * progress + pdfProgress), 99);
    $dialogElem.find('.cm-dialog__progress-text').text(displayProgress + '%');
    $dialogElem.find('.cm-dialog__progress-indicator').stop().animate({ width: displayProgress + '%' }, { duration: 500 });
    setTimeout(poll, 2000);
  }

  function poll() {
    let jobid = Cookies.get(basketId + '-dlcenter-waiting');

    if (jobid === null || jobid === 'null') {
      return;
    }

    $dialogElem = $('#cm-dialog');
    if (!$dialogElem.length) {
      createDialog();
    }

    if (!$dialogElem.hasClass('started')) {
      $dialogElem.removeClass('error').removeClass('success');
      $dialogElem.fadeIn();
    }

    $.ajax({
      url: ajaxHandlerUrl,
      type: 'post',
      data: {
        jobid: jobid,
        action: 'getpdf'
      },
      dataType: 'json',
      success: function (data) {
        if (typeof data === 'object' && data) {
          switch (data.status) {
          case 'done':
            pollDone(data);
            break;
          case 'running':
            pollRunning(data);
            break;
          case 'failed':
            pollFail(data);
            break;
          default:
            setTimeout(poll, 2000);
          }
        } else {
          setTimeout(poll, 2000);
        }
      },
      error: function () {
        // show error
        Cookies.remove(basketId + '-dlcenter-waiting', { path: '/' });
        $dialogElem.removeClass('started').addClass('error');
      }
    });
  }

  function toggleChildList(){
    let listElem = $(this).closest('.li--category');
    listElem.children('ul').toggleClass('active');
  }

  function initEvents() {
    $cmElement
      .on('click', block + '__toggle', toggleItem)
      .on('click', block + '__toggle-category', toggleItem)
      .on('click', block + '__request-pdf', requestPdf)
      .on('click', block + '__clear', clear)
      .on('click', block + '__toggle-child-ul', toggleChildList)
      .on('click', block + '__send-links', openSendForm);
  }

  function checkParents() {
    // Select parents of closest parent of selected items
    let selected = $cmElement.find(block + '__toggle:checked');
    let $parentItems = selected.closest(block + '__li').parents(block + '__li');
    selectParents($parentItems);
  }

  function init() {
    // Collection maker page
    $cmElement = $(block);
    if ($cmElement.length > 0) {
      $cmElement = $($cmElement[0]); // There can only be one

      ajaxHandlerUrl = $cmElement.data('handler');
      initializerUrl = $cmElement.data('initializer');
      imageQuality = $cmElement.data('image-quality') || 'high';
      basketId = $cmElement.data('basket') || basketId;

      checkParents();
      initEvents();

      if (Cookies.get(basketId + '-dlcenter-waiting')) {
        // start polling
        poll();
      }

      /* Open send links form if: form has errors, email is sent, send form is requested */
      if($(block+'__sent-links-error').length > 0 || $(block+'__email-sent').length > 0 || $(block+'__open-send-links').length > 0){
        openSendForm();
      }

      // If language selected previously, init this selection on load
      if( $('.brochure-language') ){
        let prefLang = localStorage.getItem('prefLang') ? localStorage.getItem('prefLang') : false;
        if( prefLang ){
          $('.brochure-language').val(prefLang).trigger('change');
        }
      }

    }else{ // Any page
      let $initCmElem = $(block + '__init-cm-cart');
      if($initCmElem.length > 0){
        // If collection maker must be initialized for custom page
        ajaxHandlerUrl = $('body').data('cm-handler');
        initializerUrl = $('body').data('cm-initializer');

        initCart();
      }
    }
  }

  return {
    init: init
  }
})();

module.exports = collectionMaker;
